import React from "react";
import ConnectSvg from "src/images/connect.svg"
import ProtectSvg from "src/images/protect.svg"
import InspectSvg from "src/images/inspect.svg"

const Tab = ({id, active, setActive}) => {
    const svgClasses = `fill-white group-hover:fill-brightgreen duration-300 ${active === id && '!fill-brightgreen'}`
    return (
        <div 
            className={`group -mb-0.5   tracking-widest relative uppercase font-semibold 
                text-sm gap-1 flex flex-col items-center py-2 md:px-12 px-4 font-display text-[#002432]  duration-300 cursor-pointer
                
            `}
            onClick={() => setActive(id)}
            onKeyPress={() => setActive(id)}
            role="button"
            tabIndex={0}
        >
            {id === 'connect' && <ConnectSvg className={svgClasses}/>}
            {id === 'protect' && <ProtectSvg className={svgClasses}/>}
            {id === 'inspect' && <InspectSvg className={svgClasses}/>}
            <span className="hidden md:block">{id}</span>
        </div>
    );
};

export default Tab;
